export enum Direction {
  next = 1,
  previous = -1,
}
